module.exports = __webpack_public_path__ + "img/swiper-3.a80a132.png";